const STEPS = [
    {
        n: "01",
        title: "Discovery & store survey",
        body:
            "On-site walkthrough — POS, ERP, network, fixtures. We map every system the platform will need to talk to.",
    },
    {
        n: "02",
        title: "Pilot deployment",
        body:
            "Single store, one anchor module — typically SmartCaddy. Live KPI dashboard from day one.",
    },
    {
        n: "03",
        title: "Integration sprint",
        body:
            "Open APIs into your POS, loyalty, ad-tech and BMS. The shared data fabric goes live across the location.",
    },
    {
        n: "04",
        title: "Roll-out & training",
        body:
            "Phase modules onto each tenant. Hands-on training for store managers, security and customer success.",
    },
    {
        n: "05",
        title: "Ambient store",
        body:
            "Sensors, predictive ops and personalised retail media running in real time, with continuous customer success support.",
    },
];

const OUTCOMES = [
    { title: "Reduce shrink", body: "Cart-side AI vision + behavioural anomaly detection at the gate." },
    { title: "Lift basket value", body: "Basket-aware promotions and personalised offers in-cart." },
    { title: "Cut checkout queues", body: "In-cart UPI, card and online payments remove the line entirely." },
    { title: "Unlock retail media", body: "Every cart screen becomes a measurable, sellable ad surface." },
    { title: "Fewer staff fires", body: "Predictive footfall and queue alerts, not after-the-fact reports." },
                    { title: "Cleaner data", body: "One identity per shopper journey across the store and across products." },
];

export default function Deployment() {
    return (
        <section
            id="deploy"
            data-testid="deployment-section"
            className="relative bg-rt-surface border-y border-white/10 py-24 lg:py-36"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <div className="rt-eyebrow mb-4">How it works / Phased deployment</div>
                        <h2 className="rt-h2 text-4xl md:text-5xl lg:text-6xl text-white mb-12">
                            From kick-off to ambient store, in five phases.
                        </h2>

                        <div className="relative">
                            <div className="absolute left-[18px] top-2 bottom-2 w-px bg-white/10" />
                            <div className="space-y-10">
                                {STEPS.map((s, i) => (
                                    <div key={i} className="relative pl-12" data-testid={`deploy-step-${i}`}>
                                        <div className="absolute left-0 top-1 w-9 h-9 border border-white/20 bg-rt-bg flex items-center justify-center font-mono text-xs text-rt-teal">
                                            {s.n}
                                        </div>
                                        <h3 className="font-heading text-xl md:text-2xl text-white tracking-tight">
                                            {s.title}
                                        </h3>
                                        <p className="mt-2 text-sm md:text-base text-rt-text2 max-w-xl">
                                            {s.body}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="lg:sticky lg:top-24">
                            <div className="rt-eyebrow mb-4">What we're optimising for</div>
                            <h3 className="rt-h2 text-3xl md:text-4xl text-white mb-2">
                                Outcomes, not vanity metrics.
                            </h3>
                            <p className="text-rt-text2 text-sm mb-8 max-w-md">
                                We design and report on the levers that move the P&amp;L — shrink,
                                basket size, conversion, retail-media revenue. We will publish
                                independently audited results as deployments mature.
                            </p>
                            <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10">
                                {OUTCOMES.map((o, i) => (
                                    <div
                                        key={i}
                                        data-testid={`outcome-${i}`}
                                        className="bg-rt-bg p-6 lg:p-7"
                                    >
                                        <div className="font-heading text-lg lg:text-xl text-white tracking-tight">
                                            {o.title}
                                        </div>
                                        <div className="mt-2 text-xs text-rt-text2 leading-relaxed">{o.body}</div>
                                    </div>
                                ))}
                            </div>
                            <a
                                href="#contact"
                                data-testid="deploy-cta-talk"
                                className="mt-8 inline-flex items-center gap-2 bg-rt-teal text-black font-medium px-5 py-3 hover:bg-rt-tealDim transition-colors"
                            >
                                Talk to the team
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
